"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntrepotSale = exports.EntrepotSalePageElement = void 0;
const wrap_native_element_1 = require("@toniq-labs/design-system/dist/esm/elements/wrap-native-element");
const element_vir_1 = require("element-vir");
const toniq_entrepot_page_header_element_1 = require("../../common/toniq-entrepot-page-header.element");
const toniq_entrepot_top_tabs_element_1 = require("../../common/toniq-entrepot-top-tabs.element");
const get_sales_1 = require("../../../../data/local-cache/dexie/get-sales");
const moment_1 = __importDefault(require("moment"));
const toniq_entrepot_sale_feature_tab_element_1 = require("./tabs/toniq-entrepot-sale-feature-tab.element");
const toniq_entrepot_sale_category_tab_element_1 = require("./tabs/toniq-entrepot-sale-category-tab.element");
const toniq_entrepot_sale_category_card_element_1 = require("./toniq-entrepot-sale-category-card.element");
const design_system_1 = require("@toniq-labs/design-system");
const toniq_entrepot_sale_preloader_element_1 = require("./toniq-entrepot-sale-preloader.element");
exports.EntrepotSalePageElement = (0, design_system_1.defineToniqElement)()({
    tagName: 'toniq-entrepot-sale-page',
    styles: (0, element_vir_1.css) `
        :host {
            display: block;
            min-height: 100vh;
            margin: 32px 0px;
        }

        ${toniq_entrepot_top_tabs_element_1.EntrepotTopTabsElement} {
            margin: 32px;
        }

        .loader {
            width: 24px;
            margin: 0 auto;
        }

        @media (max-width: 1200px) and (min-width: 900px), (max-width: 600px) {
            ${toniq_entrepot_top_tabs_element_1.EntrepotTopTabsElement} {
                margin-right: 0;
                margin-left: 0;
            }
        }
    `,
    events: {
        collectionSelected: (0, element_vir_1.defineElementEvent)(),
    },
    stateInit: {
        saleSelectedTab: {
            label: 'Featured',
            value: 'featured',
        },
        collectionSales: [],
        upcoming: [],
        inProgress: [],
        endingSoon: [],
        tabs: [],
    },
    initCallback: ({ inputs, updateState }) => {
        const saleCollections = inputs.collections.filter(collection => collection.sale);
        (0, get_sales_1.getCollectionSales)(saleCollections).then(collectionSales => {
            const upcoming = collectionSales
                .filter(collectionSale => {
                return (0, moment_1.default)(collectionSale.sales.startDate).isAfter((0, moment_1.default)().subtract(12, 'hours'));
            })
                .sort((prev, next) => prev.sales.startDate - next.sales.startDate);
            const inProgress = collectionSales
                .filter(collectionSale => {
                return ((0, moment_1.default)(collectionSale.sales.startDate).isBefore((0, moment_1.default)()) &&
                    (0, moment_1.default)(collectionSale.sales.endDate).isAfter((0, moment_1.default)()) &&
                    collectionSale.sales.percentMinted < 100);
            })
                .sort((prev, next) => next.sales.percentMinted - prev.sales.percentMinted);
            const endingSoon = collectionSales
                .filter(collectionSale => {
                return (0, moment_1.default)(collectionSale.sales.endDate).isAfter((0, moment_1.default)().subtract(12, 'hours'));
            })
                .filter(collectionSale => {
                return Number(collectionSale.sales.remaining) > 0;
            })
                .sort((prev, next) => prev.sales.endDate - next.sales.endDate);
            updateState({ collectionSales });
            updateState({ upcoming });
            updateState({ inProgress });
            updateState({ endingSoon });
            const tabs = [];
            tabs.push({
                label: 'Featured',
                value: 'featured',
            });
            if (upcoming.length) {
                tabs.push({
                    label: 'Upcoming',
                    value: 'upcoming',
                });
            }
            if (inProgress.length) {
                tabs.push({
                    label: 'In Progress',
                    value: 'inProgress',
                });
            }
            if (endingSoon.length) {
                tabs.push({
                    label: 'Ending Soon',
                    value: 'endingSoon',
                });
            }
            updateState({ tabs });
        });
    },
    renderCallback: ({ state, updateState, events, dispatch }) => {
        var _a, _b, _c, _d;
        const preloader = new Array(Math.floor(Math.random() * (8 - 4) + 4)).fill(0);
        return (0, element_vir_1.html) `
			<${toniq_entrepot_page_header_element_1.EntrepotPageHeaderElement}
                ${(0, element_vir_1.assign)(toniq_entrepot_page_header_element_1.EntrepotPageHeaderElement, {
            headerText: 'All Launches',
        })}
            ></${toniq_entrepot_page_header_element_1.EntrepotPageHeaderElement}>
            <div>
                ${state.tabs.length
            ? (0, element_vir_1.html) `
                            <${toniq_entrepot_top_tabs_element_1.EntrepotTopTabsElement}
                                ${(0, element_vir_1.assign)(toniq_entrepot_top_tabs_element_1.EntrepotTopTabsElement, {
                selected: state.saleSelectedTab,
                tabs: state.tabs,
            })}
                                ${(0, element_vir_1.listen)(toniq_entrepot_top_tabs_element_1.EntrepotTopTabsElement.events.tabChange, event => {
                const selectedTab = event.detail;
                updateState({ saleSelectedTab: selectedTab });
            })}
                            ></${toniq_entrepot_top_tabs_element_1.EntrepotTopTabsElement}>`
            : (0, element_vir_1.html) `
                        <${toniq_entrepot_top_tabs_element_1.EntrepotTopTabsElement}
                            ${(0, element_vir_1.assign)(toniq_entrepot_top_tabs_element_1.EntrepotTopTabsElement, {})}
                        ></${toniq_entrepot_top_tabs_element_1.EntrepotTopTabsElement}>`}

                ${((_a = state.saleSelectedTab) === null || _a === void 0 ? void 0 : _a.value) === 'featured'
            ? (0, element_vir_1.html) `
                              ${state.upcoming.length ||
                state.inProgress.length ||
                state.endingSoon.length
                ? (0, element_vir_1.html) `
                                  <${toniq_entrepot_sale_feature_tab_element_1.EntrepotSaleFeatureTabElement}
                                    ${(0, element_vir_1.assign)(toniq_entrepot_sale_feature_tab_element_1.EntrepotSaleFeatureTabElement, {
                    upcoming: state.upcoming,
                    inProgress: state.inProgress,
                    endingSoon: state.endingSoon,
                    updateState,
                })}
                                    ${(0, element_vir_1.listen)(toniq_entrepot_sale_feature_tab_element_1.EntrepotSaleFeatureTabElement.events.collectionSelected, event => {
                    new events.collectionSelected(event.detail);
                })}
                                ></${toniq_entrepot_sale_feature_tab_element_1.EntrepotSaleFeatureTabElement}>`
                : (0, element_vir_1.html) `
                                    <${toniq_entrepot_sale_preloader_element_1.EntrepotSalePreloaderElement}></${toniq_entrepot_sale_preloader_element_1.EntrepotSalePreloaderElement}>
                                `}
                          `
            : ''}
            </div>

            ${((_b = state.saleSelectedTab) === null || _b === void 0 ? void 0 : _b.value) === 'upcoming'
            ? (0, element_vir_1.html) `
                        <${toniq_entrepot_sale_category_tab_element_1.EntrepotSaleCategoryTabElement}
                            ${(0, element_vir_1.assign)(toniq_entrepot_sale_category_tab_element_1.EntrepotSaleCategoryTabElement, {
                categoryName: 'Upcoming',
                children: (0, element_vir_1.html) `
                                    ${state.upcoming && state.upcoming.length
                    ? (0, element_vir_1.html) `
                                              ${state.upcoming.map(collection => {
                        return (0, element_vir_1.html) `
                                                    <${toniq_entrepot_sale_category_card_element_1.EntrepotSaleCategoryCardElement}
                                                        ${(0, element_vir_1.assign)(toniq_entrepot_sale_category_card_element_1.EntrepotSaleCategoryCardElement, {
                            collectionImageUrl: collection.collection,
                            collectionName: collection.name,
                            descriptionText: collection.brief,
                            date: collection.sales.endDate,
                            dateMessage: 'Just Launched',
                            statsArray: [
                                {
                                    title: 'PRICE',
                                    icon: design_system_1.Icp16Icon,
                                    stat: collection.sales
                                        .salePrice,
                                },
                                {
                                    title: 'SIZE',
                                    stat: collection.sales.quantity,
                                },
                                {
                                    title: 'FOR SALE',
                                    stat: collection.sales
                                        .remaining,
                                },
                            ],
                        })}
                                                        ${(0, element_vir_1.listen)('click', () => {
                            dispatch(new events.collectionSelected(collection));
                        })}
                                                    ></${toniq_entrepot_sale_category_card_element_1.EntrepotSaleCategoryCardElement}>
                                                    `;
                    })}
                                          `
                    : (0, element_vir_1.html) `
                                              ${preloader.map(() => {
                        return (0, element_vir_1.html) `
                                                    <${toniq_entrepot_sale_category_card_element_1.EntrepotSaleCategoryCardElement}
                                                    ${(0, element_vir_1.assign)(toniq_entrepot_sale_category_card_element_1.EntrepotSaleCategoryCardElement, {})}
                                                    ></${toniq_entrepot_sale_category_card_element_1.EntrepotSaleCategoryCardElement}>
                                                    `;
                    })}
                                          `}
                                `,
            })}
                        ></${toniq_entrepot_sale_category_tab_element_1.EntrepotSaleCategoryTabElement}>
                    `
            : ''}

            ${((_c = state.saleSelectedTab) === null || _c === void 0 ? void 0 : _c.value) === 'inProgress'
            ? (0, element_vir_1.html) `
                        <${toniq_entrepot_sale_category_tab_element_1.EntrepotSaleCategoryTabElement}
                            ${(0, element_vir_1.assign)(toniq_entrepot_sale_category_tab_element_1.EntrepotSaleCategoryTabElement, {
                categoryName: 'In Progress',
                children: (0, element_vir_1.html) `
                                    ${state.inProgress && state.inProgress.length
                    ? (0, element_vir_1.html) `
                                              ${state.inProgress.map(collection => {
                        return (0, element_vir_1.html) `
                                                        <${toniq_entrepot_sale_category_card_element_1.EntrepotSaleCategoryCardElement}
                                                            ${(0, element_vir_1.assign)(toniq_entrepot_sale_category_card_element_1.EntrepotSaleCategoryCardElement, {
                            collectionImageUrl: collection.collection,
                            collectionName: collection.name,
                            descriptionText: collection.brief,
                            date: collection.sales.endDate,
                            statsArray: [
                                {
                                    title: 'PRICE',
                                    icon: design_system_1.Icp16Icon,
                                    stat: collection.sales
                                        .salePrice,
                                },
                                {
                                    title: 'SOLD',
                                    stat: Number(collection.sales
                                        .quantity) -
                                        Number(collection.sales
                                            .remaining),
                                },
                                {
                                    title: 'REMAINING',
                                    stat: collection.sales
                                        .remaining,
                                },
                            ],
                            progress: collection.sales
                                .percentMinted,
                        })}
                                                            ${(0, element_vir_1.listen)('click', () => {
                            dispatch(new events.collectionSelected(collection));
                        })}
                                                        ></${toniq_entrepot_sale_category_card_element_1.EntrepotSaleCategoryCardElement}>
                                                    `;
                    })}
                                          `
                    : (0, element_vir_1.html) `
                                              ${preloader.map(() => {
                        return (0, element_vir_1.html) `
                                                <${toniq_entrepot_sale_category_card_element_1.EntrepotSaleCategoryCardElement}
                                                ${(0, element_vir_1.assign)(toniq_entrepot_sale_category_card_element_1.EntrepotSaleCategoryCardElement, {})}
                                                ></${toniq_entrepot_sale_category_card_element_1.EntrepotSaleCategoryCardElement}>
                                                `;
                    })}
                                          `}
                                `,
            })}
                        ></${toniq_entrepot_sale_category_tab_element_1.EntrepotSaleCategoryTabElement}>
                    `
            : ''}

            ${((_d = state.saleSelectedTab) === null || _d === void 0 ? void 0 : _d.value) === 'endingSoon'
            ? (0, element_vir_1.html) `
                        <${toniq_entrepot_sale_category_tab_element_1.EntrepotSaleCategoryTabElement}
                            ${(0, element_vir_1.assign)(toniq_entrepot_sale_category_tab_element_1.EntrepotSaleCategoryTabElement, {
                categoryName: 'Ending Soon',
                children: (0, element_vir_1.html) `
                                    ${state.endingSoon && state.endingSoon.length
                    ? (0, element_vir_1.html) `
                                              ${state.endingSoon.map(collection => {
                        return (0, element_vir_1.html) `
                                                        <${toniq_entrepot_sale_category_card_element_1.EntrepotSaleCategoryCardElement}
                                                            ${(0, element_vir_1.assign)(toniq_entrepot_sale_category_card_element_1.EntrepotSaleCategoryCardElement, {
                            collectionImageUrl: collection.collection,
                            collectionName: collection.name,
                            descriptionText: collection.brief,
                            date: collection.sales.endDate,
                            statsArray: [
                                {
                                    title: 'PRICE',
                                    icon: design_system_1.Icp16Icon,
                                    stat: collection.sales
                                        .salePrice,
                                },
                                {
                                    title: 'SOLD',
                                    stat: Number(collection.sales
                                        .quantity) -
                                        Number(collection.sales
                                            .remaining),
                                },
                                {
                                    title: 'REMAINING',
                                    stat: collection.sales
                                        .remaining,
                                },
                            ],
                            progress: collection.sales
                                .percentMinted,
                        })}
                                                            ${(0, element_vir_1.listen)('click', () => {
                            dispatch(new events.collectionSelected(collection));
                        })}
                                                        ></${toniq_entrepot_sale_category_card_element_1.EntrepotSaleCategoryCardElement}>
                                                    `;
                    })}
                                          `
                    : (0, element_vir_1.html) `
                                              ${preloader.map(() => {
                        return (0, element_vir_1.html) `
                                                <${toniq_entrepot_sale_category_card_element_1.EntrepotSaleCategoryCardElement}
                                                ${(0, element_vir_1.assign)(toniq_entrepot_sale_category_card_element_1.EntrepotSaleCategoryCardElement, {})}
                                                ></${toniq_entrepot_sale_category_card_element_1.EntrepotSaleCategoryCardElement}>
                                                `;
                    })}
                                          `}
                                `,
            })}
                        ></${toniq_entrepot_sale_category_tab_element_1.EntrepotSaleCategoryTabElement}>
                    `
            : ''}
        `;
    },
});
exports.EntrepotSale = (0, wrap_native_element_1.wrapInReactComponent)(exports.EntrepotSalePageElement);
